/**
 * useSignOut — Wave A6 Chunk 2 (Task 2.4).
 *
 * Single source of truth for the sign-out action, shared by the Sidebar footer
 * and the TopBar avatar UserMenu so the behaviour can't drift between them.
 * Sign-out errors are non-recoverable from the UI; the auth state listener in
 * AuthContext reflects the real session state.
 */

import { useCallback } from 'react';
import { useAuth } from './useAuth';

export function useSignOut(): () => void {
  const { signOut } = useAuth();
  return useCallback(() => {
    signOut().catch(() => {
      // Intentionally swallowed — onAuthStateChange drives the UI to the
      // signed-out state regardless of this promise's outcome.
    });
  }, [signOut]);
}
